// extracted by mini-css-extract-plugin
module.exports = {"container":"AddToBasketButton_container__wh9Cb","button":"AddToBasketButton_button__Tjbtr"};